import $ from 'jquery';
import moment from 'moment';
import { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import calLogo from '../../assets/images/calender.svg';
import chevRight from '../../assets/images/chev-right.svg';
import SortIcon from '../../assets/images/sort-icon.svg';
import viewOn from '../../assets/images/view-on-icon.svg';
import dummyUser from "../../assets/images/menu/account.svg";
import Checkbox from "../../components/layouts/CheckBox";
import CustomModal from "../../components/layouts/CustomModal";
import Button from "../../components/ui/Button";
import CustomReactSelect from "../../components/ui/CustomReactSelect";
import Skeleton from "../../components/ui/Skeleton";
import { ApiConstants } from "../../constants/ApiConstants";
import { HOUSEHOLD_TYPES, USER_ROLE_TYPES } from "../../constants/Constants";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { generateUniqueId, getDateHelper, getFrequencyDates, getPriceHelper, isDateFinalized, setDateHelper } from "../../utils/Helper";
import EditAllExpences from "./EditAllExpences";
import EditExpenses from "./EditExpenses";
import MarkAsPaid from "./MarkAsPaid";




const ExpensesList = ({ payers, expensesCategories, expenseCreate, setFinalizedMonths, isRefresh }: any) => {

    let profile: any = useContext(authContext);
    profile = profile?.data;
    const expenseReminder = useMakeRequest();
    const expenses = useMakeRequest();
    const hhMembers = useMakeRequest();
    const updateExpense = useMakeRequest();

    const [isExpenseChartExpanded, setIsExpenseChartExpanded] = useState(true);

    const [expensesList, setExpensesList] = useState<any[]>([]);
    const [editExpense, setEditExpense] = useState(null);
    const [sharedBetweenMemb, setSharedBetweenMemb] = useState([]);
    const [expensesFilter, setExpensesFilter]: any = useState();
    const [expPaidMembWise, setExpPaidMembWise] = useState([])

    const [filteredExpensesList, setFilteredExpensesList] = useState<any[]>([]);
    // console.log("filteredExpensesList: ", filteredExpensesList)
    const [filteredExpPaidMembWise, setFilteredExpPaidMembWise]: any = useState([])

    const [totalExpPaid, setTotalExpPaid] = useState(0)
    const [totalExpUnPaid, setTotalExpUnPaid] = useState(0)
    const [totalExp, setTotalExp] = useState(0)

    const [filteredTotalExpPaid, setFilteredTotalExpPaid] = useState(0)
    const [filteredTotalExpUnPaid, setFilteredTotalExpUnPaid] = useState(0)
    const [filteredTotalExp, setFilteredTotalExp] = useState(0)

    const [totalExpFromJointAccount, setTotalExpFromJointAccount] = useState(0)

    const [deleteData, setDeleteData]: any = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const [showDeleteAllExpenseModal, setShowDeleteAllExpenseModal] = useState(false)
    const [showDeleteExpenseModal, setShowDeleteExpenseModal] = useState(false)

    const [selectedExpense, setSelectedExpense] = useState<string[]>([]);
    const [selectedExpenseArrayObj, setSelectedExpenseArrayObj] = useState<any[]>([]);

    // console.log("selectedExpenseArrayObj :", selectedExpenseArrayObj)
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const [isOpen, setIsOpen] = useState(true);

    const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>({
        totalHours: false,
        totalExpenses: false,
        totalPaid: false,
        totalUnpaid: false,
        currentBalances: false,
        finalizedBalances: false
    });

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };


    const toggleSelectExpense = (id: string, expense: any) => {
        setSelectedExpense(prev => {
            const isSelected = prev.includes(id);

            if (isSelected) {
                // Remove from both arrays
                setSelectedExpenseArrayObj(prevArr => prevArr.filter(e => e.unique_id !== expense.unique_id));
                return prev.filter(cid => cid !== id);
            } else {
                // Transform the expense into required format
                const transformed = {
                    ...expense,
                    e_id: expense.uuid,
                    unique_id: expense.unique_id,
                    m_date: expense.date,
                    new_date: expense.s_date.split("T")[0],
                    ec_id: expense.expense_cat.value,
                    payer: expense.paid_by?.value || "",
                    amount: Number(expense.amount),
                    is_modified: expense.is_modified,
                    is_deleted: 1,
                    desc: expense.desc
                };

                // Add to both arrays
                setSelectedExpenseArrayObj(prevArr => [...prevArr, transformed]);
                return [...prev, id];
            }
        });
    };

    // Calculate allowed expenses first
    const isAdmin = profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN;

    const allowedExpenses = isAdmin
        ? filteredExpensesList.filter(expense => !expense.is_finalized)
        : filteredExpensesList.filter(expense => {
            const isSharedWithUser = expense?.shared_between?.some(
                (s: any) => s?.split_user?.uuid === profile?.uuid
            );
            return (
                !expense.is_finalized &&
                (
                    Number(expense?.createdBy) === Number(profile?.id) ||
                    expense?.paid_by?.value === profile?.uuid ||
                    isSharedWithUser ||
                    profile?.hh_member?.member_type === HOUSEHOLD_TYPES?.ADMIN
                )
            );
        });

    // console.log("allowedExpenses: ", allowedExpenses)
    const hasNonEditable = allowedExpenses?.length <= 0
    // Correct "allSelected" condition
    const allSelected =
        allowedExpenses.length > 0 &&
        selectedExpense.length === allowedExpenses.length;

    // console.log("allSelected: ", allSelected)

    const toggleSelectAll = () => {
        if (allSelected) {
            setSelectedExpense([]);
            setSelectedExpenseArrayObj([]);
            return;
        }

        const allIds = allowedExpenses.map(exp => exp.unique_id);

        const transformed = allowedExpenses.map(item => ({
            ...item,
            e_id: item.uuid,
            unique_id: item.unique_id,
            m_date: item.date,
            new_date: item.s_date.split("T")[0],
            ec_id: item.expense_cat.value,
            payer: item.paid_by?.value,
            amount: Number(item.amount),
            is_modified: item.is_modified,
            is_deleted: 1,
            desc: item.desc
        }));

        setSelectedExpenseArrayObj(transformed);
        setSelectedExpense(allIds);
    };


    const getExpenses = () => {
        const fetch = async () => {
            setIsLoading(true)
            await expenses.makeRequest({ url: ApiConstants?.ExpensesGet })
            setExpensesFilter({
                ec_id: null,
                payer: null,
                s_date: null,
                e_date: null,
                amount: ''
            });
        }
        fetch()
    }

    useEffect(() => {
        if (expenses?.status && hhMembers?.status) {
            const expensesRows = expenses?.data?.data?.rows;
            const modifiedExpenses = expenses?.data?.data?.modified_expenses;
            const TotalPaymentFromJointAccount = expenses?.data?.data?.joint_total || 0;
            setTotalExpFromJointAccount(TotalPaymentFromJointAccount)
            let expensesArr: any = [];

            const expPaidMembWiseArr: any = {};
            let totalExpensesPaid = 0;
            let totalExpensesUnPaid = 0;
            let totalExpenses = 0;

            hhMembers?.data?.data?.forEach((member: any) => {
                const userUUID = member?.user?.uuid;
                if (userUUID) {
                    expPaidMembWiseArr[userUUID] = {
                        name: member?.user?.name,
                        profile_pic: member?.user?.profile_pic,
                        email: member?.user?.email,
                        expenses_paid: 0
                    };
                }
            });

            expPaidMembWiseArr['joint_account'] = {
                name: 'Joint Accounts',
                profile_pic: null,
                email: null,
                expenses_paid: 0
            };

            setFinalizedMonths(expenses?.data?.data?.finalized_months)
            if (expensesRows?.length > 0) {
                expensesRows.forEach((exp: any) => {
                    const freqDays = getFrequencyDates(
                        exp?.s_date,
                        exp?.e_date,
                        exp?.f_type,
                        exp?.f_value,
                        exp?.s_days_or_months
                    );


                    const mappedExpenses = freqDays.map((date: string) => {
                        const is_finalized = isDateFinalized(date, expenses?.data?.data?.finalized_months || []);
                        const modifiedExpense = modifiedExpenses.find(
                            (modExp: any) => {
                                return moment(modExp.m_date).format('YYYY-MM-DD') === date && modExp.e_id === exp.id
                            });

                        if (profile?.hh_member?.member_type != HOUSEHOLD_TYPES?.ADMIN) {
                            // console.log("DATE:", date);
                            // console.log("CREATED_AT:", profile?.hh_member?.created_at);
                            // console.log(
                            //     "isBefore:",
                            //     moment(date).isBefore(moment(profile?.hh_member?.created_at), 'day')
                            // );
                            if (moment(date).isBefore(moment(profile?.hh_member?.created_at).format('YYYY-MM-DD'))) {
                                return;
                            }
                        }
                        if (modifiedExpense && modifiedExpense.is_deleted) {
                            return null;
                        }

                        const isUnpaid = modifiedExpense ? modifiedExpense.is_unpaid === 1 : exp?.is_unpaid === 1;
                        const amount = modifiedExpense?.amount || exp?.amount;

                        if (modifiedExpense) {
                            return {
                                ...exp,
                                ...modifiedExpense,
                                paid_by: modifiedExpense?.is_unpaid === 1 ? { value: 0, label: 'Unpaid' } : modifiedExpense?.paid_by,
                                date,
                                is_modified: true,
                                is_unpaid: isUnpaid,
                                amount,
                                is_finalized,
                                unique_id: generateUniqueId(modifiedExpense?.uuid)
                            };
                        } else {
                            return {
                                date,
                                ...exp,
                                paid_by: exp?.is_unpaid === 1 ? { value: 0, label: 'Unpaid' } : exp?.paid_by,
                                is_modified: false,
                                is_unpaid: isUnpaid,
                                amount,
                                is_finalized,
                                unique_id: generateUniqueId(exp?.uuid)
                            };
                        }
                    }).filter(Boolean);
                    expensesArr.push(...mappedExpenses);
                    mappedExpenses.forEach((expense: any) => {
                        const totalAmount = Number(expense.amount);

                        if (expense.is_unpaid) {
                            totalExpensesUnPaid += totalAmount;
                        } else {
                            totalExpensesPaid += totalAmount;

                            // Check if it's a joint account expense
                            if (expense.is_joint_account || expense.paid_by?.value === "01" || expense.paid_by?.label?.toLowerCase().includes("joint")) {
                                expPaidMembWiseArr['joint_account'].expenses_paid += totalAmount;
                            } else {
                                const payerUUID = expense.paid_by?.value;
                                if (payerUUID && payerUUID !== 0 && expPaidMembWiseArr[payerUUID]) {
                                    expPaidMembWiseArr[payerUUID].expenses_paid += totalAmount;
                                }
                            }
                        }
                        totalExpenses += totalAmount;
                    });
                });
                expensesArr.sort((a: any, b: any) => moment(a.date).valueOf() - moment(b.date).valueOf());
            }
            setTotalExpPaid(totalExpensesPaid);
            setTotalExpUnPaid(totalExpensesUnPaid);
            setTotalExp(totalExpenses);

            setFilteredTotalExpPaid(totalExpensesPaid);
            setFilteredTotalExpUnPaid(totalExpensesUnPaid);
            setFilteredTotalExp(totalExpenses);
            setExpPaidMembWise(expPaidMembWiseArr);
            setFilteredExpPaidMembWise(expPaidMembWiseArr);
            setExpensesList(expensesArr);
            setFilteredExpensesList(expensesArr);
            setIsLoading(false)
        }
    }, [expenses?.status, hhMembers?.status]);


    useEffect(() => {
        getExpenses()
        hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
    }, [updateExpense?.status])

    const handleTableScroll = () => {
        return
    }
    const handleFilter = (type: string = 'FILTER') => {

        if (type === 'RESET') {
            setExpensesFilter({
                ec_id: null,
                payer: null,
                s_date: null,
                e_date: null,
                amount: ''
            });

            setFilteredExpensesList(expensesList);
            setFilteredExpPaidMembWise(expPaidMembWise);

            setFilteredTotalExpPaid(totalExpPaid);
            setFilteredTotalExpUnPaid(totalExpUnPaid);
            setFilteredTotalExp(totalExp);

            return;
        }

        let { ec_id, payer, s_date, e_date, amount } = expensesFilter || {};

        const categoryId = ec_id?.value;
        const payerId = payer?.value;

        const filteredExpenses = expensesList.filter((expense: any) => {

            let isMatch = true;

            const expenseDate = moment(expense?.date);

            // ✅ Date filtering (inclusive)
            if (s_date && e_date) {
                if (
                    expenseDate.isBefore(moment(s_date).startOf('day')) ||
                    expenseDate.isAfter(moment(e_date).endOf('day'))
                ) {
                    isMatch = false;
                }
            } else if (s_date) {
                if (expenseDate.isBefore(moment(s_date).startOf('day'))) {
                    isMatch = false;
                }
            } else if (e_date) {
                if (expenseDate.isAfter(moment(e_date).endOf('day'))) {
                    isMatch = false;
                }
            }

            // ✅ Category filter
            if (categoryId && expense?.expense_cat?.value !== categoryId) {
                isMatch = false;
            }

            // ✅ Payer filter (handles member / unpaid / joint)
            if (payerId) {

                console.log("payerId; ", payerId)
                console.log("expense ", expense)

                // 🔹 Unpaid selected
                if (payerId === "0") {
                    if (expense?.paid_by?.value !== 0) {
                        isMatch = false;
                    }
                }

                // 🔹 Joint Account selected
                else if (payerId === "01") {
                    if (expense?.is_joint_account !== 1 || expense?.is_unpaid === 1) {
                        isMatch = false;
                    }
                }

                // 🔹 Normal member selected
                else {
                    if (
                        expense?.is_unpaid === 1 ||
                        expense?.is_joint_account === 1 ||
                        expense?.paid_by?.value !== payerId
                    ) {
                        isMatch = false;
                    }
                }
            }

            // ✅ Amount filter
            if (amount && Number(expense?.amount) !== Number(amount)) {
                isMatch = false;
            }

            return isMatch;
        });

        // ===============================
        // Totals Calculation
        // ===============================

        let totalExpensesPaid = 0;
        let totalExpensesUnPaid = 0;

        const expPaidMembWiseArr: any = {};

        hhMembers?.data?.data?.forEach((member: any) => {
            const userUUID = member?.user?.uuid;

            if (userUUID) {
                expPaidMembWiseArr[userUUID] = {
                    name: member?.user?.name,
                    profile_pic: member?.user?.profile_pic,
                    email: member?.user?.email,
                    expenses_paid: 0
                };
            }
        });

        expPaidMembWiseArr['joint_account'] = {
            name: 'Joint Accounts',
            profile_pic: null,
            email: null,
            expenses_paid: 0
        };

        filteredExpenses.forEach((expense: any) => {

            if (expense.is_unpaid === 1) {
                totalExpensesUnPaid += Number(expense.amount);
            } else {
                totalExpensesPaid += Number(expense.amount);

                // Joint account expense
                if (expense.is_joint_account === 1 || expense.paid_by?.value === "01" || expense.paid_by?.label?.toLowerCase().includes("joint")) {
                    expPaidMembWiseArr['joint_account'].expenses_paid += Number(expense.amount);
                }
                // Member expense
                else {
                    const payerUUID = expense.paid_by?.value;

                    if (payerUUID) {
                        if (!expPaidMembWiseArr[payerUUID]) {
                            expPaidMembWiseArr[payerUUID] = {
                                name: expense.paid_by?.label,
                                expenses_paid: 0
                            };
                        }

                        expPaidMembWiseArr[payerUUID].expenses_paid += Number(expense.amount);
                    }
                }
            }
        });

        setFilteredTotalExpPaid(totalExpensesPaid);
        setFilteredTotalExpUnPaid(totalExpensesUnPaid);
        setFilteredTotalExp(totalExpensesPaid + totalExpensesUnPaid);

        setFilteredExpensesList(filteredExpenses);
        setFilteredExpPaidMembWise(expPaidMembWiseArr);
    };


    useEffect(() => {
        if (updateExpense?.status || expenseCreate?.status) {
            getExpenses()
            setSelectedExpense([]);
            setSelectedExpenseArrayObj([])
            setShowDeleteExpenseModal(false)
            setShowDeleteAllExpenseModal(false)
            $('.btn-close-delete-exp-modal').click();
            $('.btn-close-all-chores-modal').click();
        }
    }, [updateExpense?.status, expenseCreate?.status])

    const handleDeleteExpense = () => {
        updateExpense.makeRequest({
            url: ApiConstants?.ExpensesUpdate,
            payload: {
                e_id: deleteData?.uuid,
                is_deleted: 1,
                m_date: deleteData?.date,
                is_modified: deleteData?.is_modified
            }
        })
    }

    useEffect(() => {
        if (isRefresh) {
            setExpensesFilter({
                ec_id: null,
                payer: null,
                s_date: null,
                e_date: null,
                amount: ''
            });
            setFilteredExpensesList(expensesList);
            setFilteredExpPaidMembWise(expPaidMembWise);

            setFilteredTotalExpPaid(totalExpPaid);
            setFilteredTotalExpUnPaid(totalExpUnPaid);
            setFilteredTotalExp(totalExp);
            expenses.makeRequest({ url: ApiConstants?.ExpensesGet })
        }
    }, [isRefresh])
    useEffect(() => {
        return () => {
            $('.modal-backdrop').remove();
        }
    }, [])

    const handleSort = (key: any) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const handleDeleteAllExpense = () => {
        console.log("selectedExpenseArrayObj ", selectedExpenseArrayObj)

        toast.promise(
            updateExpense.makeRequest({ payload: selectedExpenseArrayObj, url: ApiConstants?.AllExpenseUpdate }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
        setSelectedExpense([]);
        setSelectedExpenseArrayObj([])
    }

    const toggleSection = (section: string) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    }

    return (
        <>
            <div className="page-padding-x box-bg pt-2">
                <div className="com-input-grp mb-4 mt-2">
                    <div className="input-header">
                        <label className="form-label-large">Expense Chart</label>
                        <div className="filter-section" onClick={() => setIsExpenseChartExpanded(!isExpenseChartExpanded)} style={{ cursor: 'pointer' }}>
                            <span>Filter</span>
                            <img
                                src={chevRight}
                                alt="chevron"
                                style={{
                                    transform: isExpenseChartExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            />
                        </div>
                    </div>
                </div>

                {isExpenseChartExpanded && (
                    <>
                        <div className="row gy-3">
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">Start Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="Select Date"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={expensesFilter?.s_date ? moment(expensesFilter?.s_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setExpensesFilter({ ...expensesFilter, s_date: setDateHelper({ date: start_date }), e_date: '' })
                                        }}
                                        minDate={moment(profile?.hh_member?.billing_date).toDate()}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">End Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="Select Date"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={expensesFilter?.e_date ? moment(expensesFilter?.e_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setExpensesFilter({ ...expensesFilter, e_date: setDateHelper({ date: start_date }) })
                                        }}
                                        minDate={new Date(new Date(expensesFilter?.s_date).setDate(new Date(expensesFilter?.s_date).getDate() + 1))}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <CustomReactSelect
                                    label="Expense Type"
                                    value={expensesFilter?.ec_id}
                                    options={[
                                        ...(Array.isArray(expensesCategories?.data?.data) ? expensesCategories?.data?.data : []),
                                    ]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Expense Type"
                                    isLoading={expensesCategories?.loading}
                                    onChange={(selectedOption: any) => {
                                        setExpensesFilter({ ...expensesFilter, ec_id: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />
                            </div>
                            <div className="col-6">
                                <CustomReactSelect
                                    label="Payer"
                                    value={expensesFilter?.payer}
                                    options={[
                                        ...(Array.isArray(payers) ? payers : []),
                                    ]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Payer"
                                    onChange={(selectedOption: any) => {
                                        setExpensesFilter({ ...expensesFilter, payer: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />
                            </div>
                            <div className="col-12">
                                <div className="com-input-grp">
                                    <label className="form-label">Amount</label>
                                    <div className='custom-select'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter amount"
                                            value={expensesFilter?.amount}
                                            onInput={(e: any) => {
                                                let inputValue = e.target.value;
                                                inputValue = inputValue.replace(/[^0-9.]/g, '');
                                                const decimalCount = inputValue.split('.').length - 1;
                                                if (decimalCount > 1) {
                                                    const parts = inputValue.split('.');
                                                    inputValue = parts[0] + '.' + parts.slice(1).join('');
                                                }
                                                const parts = inputValue.split('.');
                                                if (parts[0].length > 7) {
                                                    parts[0] = parts[0].substring(0, 7);
                                                }
                                                if (parts.length > 1) {
                                                    parts[1] = parts[1]?.substring(0, 2);
                                                }
                                                inputValue = parts.join('.');
                                                e.target.value = inputValue;
                                                setExpensesFilter({ ...expensesFilter, amount: e.target.value })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='pb-4 d-flex'>
                            <Button className='custom-grayed-btn modal-light-btn mt-2 me-4' style={{ width: "50%" }} type="button" onClick={() => handleFilter('RESET')}>Reset</Button>
                            <Button className='com-btn mt-2 ' style={{ width: "50%" }} type="button" onClick={handleFilter}>Filter</Button>
                        </div>
                    </>
                )}
            </div>

            <div className="box-bg pt-2">
                <div className="page-padding-x">
                    <div className="table-scroll-top" >
                        <div className='table-responsive table-y-scroll-2 report-table mb-2' onScroll={handleTableScroll}>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>
                                            <Checkbox
                                                checked={allSelected}
                                                onChange={!hasNonEditable ? toggleSelectAll : undefined}
                                                disabled={hasNonEditable}
                                            />
                                            {/* <input
                                                type="checkbox"
                                                checked={allSelected}
                                                onChange={!hasNonEditable ? toggleSelectAll : undefined}
                                                disabled={hasNonEditable}
                                                className={`custom-checkbox ${hasNonEditable ? "checkbox-disabled" : ""}`}
                                            /> */}
                                        </th>

                                        <th>Date
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                                onClick={() => handleSort('date')}
                                            />
                                        </th>
                                        <th className="text-center">Expense Type
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                                onClick={() => handleSort('exp_type')}
                                            />
                                        </th>

                                        <th className="text-center">Amount
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                                onClick={() => handleSort('amount')}
                                            />
                                        </th>
                                        <th className="text-center">Payer
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                                onClick={() => handleSort('payer')}
                                            />
                                        </th>
                                        <th className="text-center">Description
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                                onClick={() => handleSort('description')}
                                            />
                                        </th>
                                        {/* <th className="text-center">Individual Share
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                                onClick={() => handleSort('individual_share')}
                                            />
                                        </th> */}
                                        <th className="text-center">Shared Between
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                                onClick={() => handleSort('shared_between')}
                                            />
                                        </th>
                                        <th className="text-center">Payment Status
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                                onClick={() => handleSort('payment_status')}
                                            />
                                        </th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        isLoading ?
                                            Array.from({ length: 10 })?.map((_, key) => (
                                                <tr key={key}>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '100px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '140px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                    </td>
                                                </tr>
                                            )) :

                                            filteredExpensesList?.length > 0 ?

                                                [...filteredExpensesList]
                                                    ?.sort((a, b) => {
                                                        const { key, direction } = sortConfig;
                                                        if (!key) return 0;

                                                        let aValue, bValue;

                                                        switch (key) {
                                                            case 'date':
                                                                aValue = new Date(a.date);
                                                                bValue = new Date(b.date);
                                                                break;
                                                            case 'exp_type':
                                                                aValue = a.expense_cat?.label?.toLowerCase();
                                                                bValue = b.expense_cat?.label?.toLowerCase();
                                                                break;
                                                            case 'description':
                                                                aValue = a.desc?.toLowerCase();
                                                                bValue = b.desc?.toLowerCase();
                                                                break;
                                                            case 'amount':
                                                                aValue = a.amount?.toLowerCase();
                                                                bValue = b.amount?.toLowerCase();
                                                                break;
                                                            case 'payer':
                                                                aValue = a.paid_by?.label?.toLowerCase();
                                                                bValue = b.paid_by?.label?.toLowerCase();
                                                                break;
                                                            case 'shared_between':
                                                                aValue = a.shared_between[0].split_user?.name?.toLowerCase()
                                                                bValue = b.shared_between[0].split_user?.name?.toLowerCase()
                                                                break;
                                                            case 'payment_status':
                                                                aValue = a.is_unpaid ? 1 : 0;
                                                                bValue = b.is_unpaid ? 1 : 0;
                                                                break;
                                                            default:
                                                                return 0;
                                                        }

                                                        if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                                                        if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                                                        return 0;
                                                    })?.map((expense: any, expenseIndex: any) => {
                                                        const date = getDateHelper({ date: expense?.date, format: 'MM/DD/YYYY' });
                                                        const desc = expense?.desc;
                                                        const payer = expense?.paid_by?.label;
                                                        const expCat = expense?.expense_cat?.label;
                                                        const amount = expense?.amount;
                                                        // const canEdit = Number(expense?.createdBy) === Number(profile?.id) ? 1 : profile?.hh_member?.member_type === HOUSEHOLD_TYPES?.ADMIN ? 1 : 0;
                                                        const isFinalized = expense?.is_finalized;
                                                        const sharedBetween = expense?.shared_between;
                                                        const individualShare = Number(amount) / expense?.shared_between?.length;
                                                        const paymentStatus = expense?.is_unpaid ? 'Unpaid' : 'Paid';
                                                        const jointAccountStatus = expense?.is_joint_account ? 'Joint Account' : payer;

                                                        const isSharedWithUser = expense?.shared_between?.some(
                                                            (s: any) => s?.split_user?.uuid === profile?.uuid
                                                        );
                                                        console.log("expense?.shared_between: ", expense?.shared_between)
                                                        console.log("isSharedWithUser: ", isSharedWithUser)
                                                        const canEdit = (
                                                            Number(expense?.createdBy) === Number(profile?.id) ||
                                                            expense?.paid_by?.value === profile?.uuid ||
                                                            isSharedWithUser ||
                                                            profile?.hh_member?.member_type === HOUSEHOLD_TYPES?.ADMIN
                                                        ) ? 1 : 0;

                                                        return (
                                                            <>
                                                                <tr key={expenseIndex}>
                                                                    <td>
                                                                        <Checkbox
                                                                            id={`chore-checkbox-${expense.unique_id}`}
                                                                            checked={selectedExpense.includes(expense.unique_id)}
                                                                            disabled={isFinalized}
                                                                            onChange={() => {
                                                                                const isAdmin = profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN;
                                                                                if (isAdmin || canEdit) {
                                                                                    toggleSelectExpense(expense.unique_id, expense);
                                                                                } else {
                                                                                    toast.error("You can edit expense that are paid by you, shared with you, or created by you.");
                                                                                }
                                                                            }}
                                                                        />
                                                                        {/* <input
                                                                            type="checkbox"
                                                                            checked={selectedExpense.includes(expense.unique_id)}
                                                                            onChange={() => {
                                                                                const isAdmin = profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN;
                                                                                if (isAdmin || canEdit) {
                                                                                    toggleSelectExpense(expense.unique_id, expense);
                                                                                } else {
                                                                                    toast.error("You can edit chores that are paid by you, shared with you, or created by you.");
                                                                                }
                                                                            }}
                                                                            className={`custom-checkbox ${!canEdit ? "checkbox-disabled" : ""}`}
                                                                        /> */}
                                                                    </td>

                                                                    <td className="text-center">{date}</td>
                                                                    <td className="text-center">{expCat}</td>

                                                                    <td className="text-center">{amount}</td>
                                                                    <td className="text-center">{jointAccountStatus}</td>
                                                                    <td className="text-center">{desc}</td>
                                                                    {/* <td className="text-center">{getPriceHelper(individualShare)}</td> */}
                                                                    <td className="text-center">{"View"}{sharedBetween?.length >= 1 ?
                                                                        <>
                                                                            <button type='button' data-bs-toggle="modal" data-bs-target="#sharedBetweenModal" className='view-shared' onClick={() => setSharedBetweenMemb(sharedBetween)}><img className="calIcon ms-2" src={viewOn} alt="eye" /></button ></>
                                                                        : ''}</td>
                                                                    <td className='pay-status'>{paymentStatus}</td>
                                                                    <td className='pay-status'>
                                                                        <div className="d-flex align-items-center">
                                                                            {
                                                                                isFinalized ? 'Finalized' :
                                                                                    canEdit ?
                                                                                        <>
                                                                                            <span className="action-icon cursor-pointer"
                                                                                                role="button"
                                                                                                tabIndex={0}
                                                                                                onKeyDown={(e) => {
                                                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                                                        e.preventDefault();
                                                                                                        e.currentTarget.click();
                                                                                                    }
                                                                                                }}
                                                                                                data-bs-toggle="modal"
                                                                                                data-bs-target="#expensesUpdateModal"
                                                                                                onMouseDown={(e) => e.preventDefault()}
                                                                                                onClick={(e: any) => {
                                                                                                    e.preventDefault();
                                                                                                    setSelectedExpense([]);
                                                                                                    setSelectedExpenseArrayObj([])
                                                                                                    setEditExpense(expense)
                                                                                                }}
                                                                                            >
                                                                                                <svg
                                                                                                    className="edit-icon"
                                                                                                    width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                    <g clip-path="url(#clip0_58545_4835)">
                                                                                                        <path d="M6.98438 3.5L10.4934 7.00001" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                        <path d="M7.56836 12.832H12.8319" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                        <path d="M1.16804 9.33953L9.31264 1.17069C9.3162 1.16709 9.32203 1.16706 9.32565 1.17063L12.8281 4.66833C12.8304 4.67062 12.8304 4.6743 12.8281 4.67658L4.66333 12.8348H1.16797L1.16804 9.33953Z" stroke="#263C4A" stroke-width="0.875" />
                                                                                                    </g>
                                                                                                    <defs>
                                                                                                        <clipPath id="clip0_58545_4835">
                                                                                                            <rect width="14" height="14" fill="white" />
                                                                                                        </clipPath>
                                                                                                    </defs>
                                                                                                </svg>


                                                                                            </span>
                                                                                            <div className="vertical-icon-separator" />
                                                                                            <span
                                                                                                className="action-icon del cursor-pointer"
                                                                                                role="button"
                                                                                                tabIndex={0}
                                                                                                onKeyDown={(e) => {
                                                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                                                        e.preventDefault();
                                                                                                        e.currentTarget.click();
                                                                                                    }
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    setShowDeleteExpenseModal(true)
                                                                                                    setSelectedExpense([]);
                                                                                                    setSelectedExpenseArrayObj([])
                                                                                                    setDeleteData(expense)

                                                                                                }}>
                                                                                                <svg className="del-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                    <path d="M5.25 6.70703H8.75" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                    <path d="M6.125 9.04297H7.875" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                    <path d="M11.375 3.20703L10.7917 12.832H3.20833L2.625 3.20703" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                    <path d="M1.16797 3.20964H4.66797M4.66797 3.20964L5.54297 1.16797H8.45964L9.33464 3.20964M4.66797 3.20964H9.33464M12.8346 3.20964H9.33464" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                </svg>
                                                                                            </span>
                                                                                        </>

                                                                                        // <span className="action-icon cursor-pointer"
                                                                                        //     data-bs-toggle="modal"
                                                                                        //     data-bs-target="#expensesUpdateModal"
                                                                                        //     onMouseDown={(e) => e.preventDefault()}
                                                                                        //     onClick={(e: any) => {
                                                                                        //         e.preventDefault();
                                                                                        //         setSelectedExpense([]);
                                                                                        //         setSelectedExpenseArrayObj([])
                                                                                        //         setEditExpense(expense)
                                                                                        //     }}
                                                                                        // >
                                                                                        //     <a className='icon-edit'></a>
                                                                                        // </span>
                                                                                        // <span
                                                                                        //     className="action-icon del cursor-pointer"
                                                                                        //     // data-bs-toggle="modal"
                                                                                        //     // data-bs-target="#deleteExpenseModal"
                                                                                        //     onClick={() => {
                                                                                        //         setShowDeleteExpenseModal(true)
                                                                                        //         setSelectedExpense([]);
                                                                                        //         setSelectedExpenseArrayObj([])
                                                                                        //         setDeleteData(expense)

                                                                                        //     }}>
                                                                                        //     <i className="icon-delete"></i>
                                                                                        // </span>

                                                                                        : '...'}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })
                                                :
                                                <>
                                                    <tr>
                                                        <td colSpan={20}>

                                                            <p className="text-center mt-3">No Record Found</p>
                                                        </td>
                                                    </tr>

                                                </>
                                    }
                                    {/* <tr>
                                                <td className="text-center">
                                                    <div className="spinner-border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </td>
                                            </tr> */}
                                </tbody>
                            </table>
                        </div>

                        {/* <button className="t-scroll-btn">Move to top</button> */}
                    </div>


                    <div className="d-flex align-items-center justify-content-center">
                        <button
                            className="com-btn me-2"
                            style={{ width: "50%" }}
                            data-bs-toggle={selectedExpense?.length > 0 ? "modal" : ""}
                            data-bs-target={selectedExpense?.length > 0 ? "#editAllExpencesModal" : ""}
                            onClick={(e) => {
                                if (selectedExpense?.length === 0) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                        >
                            {/* <img src={editIcon} className="me-2 btn-icon" /> */}
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="me-2 btn-icon"
                            >
                                <path
                                    d="M9.97754 5L14.9905 10"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M10.8135 18.334H18.3328"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M1.66709 13.3397L13.3022 1.66991C13.3073 1.66476 13.3156 1.66471 13.3208 1.66981L18.3243 6.66654C18.3276 6.6698 18.3276 6.67506 18.3243 6.67832L6.66037 18.3329H1.66699L1.66709 13.3397Z"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                />
                            </svg>
                            Edit
                        </button>
                        <button
                            className="com-btn"
                            style={{ width: "50%" }}
                            // data-bs-toggle={selectedExpense?.length > 0 ? "modal" : ""}
                            // data-bs-target={selectedExpense?.length > 0 ? "#deleteAllExpenseModal" : ""}
                            onClick={(e) => {
                                if (selectedExpense?.length > 0) {
                                    setShowDeleteAllExpenseModal(true)
                                }
                            }}
                        >
                            {/* <img src={binIcon} className="me-2 btn-icon" />  */}
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="me-2 btn-icon"
                            >
                                <path
                                    d="M7.49902 9.58594H12.499"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M8.74902 12.9141H11.249"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M16.249 4.58594L15.4157 18.3359H4.58236L3.74902 4.58594"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M1.66797 4.58073H6.66797M6.66797 4.58073L7.91797 1.66406H12.0846L13.3346 4.58073M6.66797 4.58073H13.3346M18.3346 4.58073H13.3346"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            Delete
                        </button>
                    </div>



                    <div className="d-flex align-items-center justify-content-center mt-2">
                        <button
                            className="com-btn me-2"
                            style={{ width: "50%" }}
                            data-bs-toggle={selectedExpense?.length > 0 ? "modal" : ""}
                            data-bs-target={selectedExpense?.length > 0 ? "#markAsPaidModal" : ""}
                            onClick={(e) => {
                                if (selectedExpense?.length === 0) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                        >
                            {/* <img src={rightTickIcon} className="me-2 btn-icon" /> */}
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="me-2 btn-icon"
                            >
                                <path
                                    d="M3.33594 9.33202L5.66927 11.6654L12.6693 4.33203"
                                    stroke="currentColor"
                                    stroke-linecap="square"
                                />
                            </svg>
                            Mark as Paid
                        </button>

                        <button
                            className="com-btn"
                            style={{ width: "50%" }}
                            onClick={(e) => {
                                // if (selectedExpense?.length === 0) {
                                //     e.preventDefault();
                                //     e.stopPropagation();
                                // }

                                toast.promise(
                                    expenseReminder.makeRequest({
                                        url: ApiConstants?.sendExpenseReminder,
                                        payload: {
                                            hh_id: profile?.hh_member?.household?.id,
                                        }
                                    }),
                                    {
                                        loading: 'Processing...',
                                        success: (data: any) => data.message,
                                        error: (error: any) => error.message,
                                    }
                                );
                            }}
                        >
                            {/* <img src={notification} className="me-2 btn-icon" /> */}
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="me-2 btn-icon"
                            >
                                <path
                                    d="M12.9173 15C12.9173 16.6108 11.6115 17.9167 10.0007 17.9167C8.38982 17.9167 7.08398 16.6108 7.08398 15"
                                    stroke={"currentColor"}
                                    stroke-width="1.04167"
                                    stroke-linecap="square"
                                />
                                <path
                                    d="M16.0259 15.0007H3.97406C3.15996 15.0007 2.5 14.3407 2.5 13.5266C2.5 13.1357 2.6553 12.7607 2.93174 12.4842L4.16667 11.2493V7.91732C4.16667 4.69566 6.77834 2.08398 10 2.08398C13.2217 2.08398 15.8333 4.69565 15.8333 7.91732V11.2493L17.0682 12.4842C17.3447 12.7607 17.5 13.1357 17.5 13.5266C17.5 14.3407 16.84 15.0007 16.0259 15.0007Z"
                                    stroke={"currentColor"}
                                    stroke-width="1.04167"
                                    stroke-linecap="square"
                                />
                            </svg>
                            Send Reminder</button>
                    </div>
                </div>
                <div className="divider" />
                <div className='summary-section'>
                    <h3 className='summary-title'>Summary</h3>

                    {/* Total Hours Projected */}
                    <div className='summary-item' tabIndex={0}>
                        <div className='summary-item-header'>
                            <span className='summary-item-label'>Total Expenses</span>
                            <span className='summary-item-value'>{getPriceHelper(filteredTotalExp) || 0}</span>
                        </div>
                    </div>

                    {/* Total Hours Completed */}
                    <div
                        className='summary-item'
                        tabIndex={0}
                        role='button'
                        aria-expanded={expandedSections.totalHours}
                        onClick={() => toggleSection('totalHours')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleSection('totalHours');
                            }
                        }}
                    >
                        <div className='summary-item-header'>
                            <div className='summary-item-left'>
                                <span className='summary-item-label'>Total Paid Expenses</span>
                                <span className='summary-item-arrow'>
                                    <img className={`accordion-arrow ${expandedSections.totalHours ? 'expanded' : ''}`} src={chevRight} alt="" />
                                </span>
                            </div>
                            <span className='summary-item-value'>
                                {getPriceHelper(filteredTotalExpPaid) || 0}
                            </span>
                        </div>
                    </div>
                    {expandedSections.totalHours && (
                        <div className='summary-item-expanded'>
                            {
                                Object.values(filteredExpPaidMembWise)?.length > 0 ? Object.values(filteredExpPaidMembWise)?.map((user: any, key: number) => (
                                    <div className='summary-sub-item' key={key}>
                                        <span className='summary-sub-label'>{user?.name?.toLowerCase().includes('joint') ? 'Joint Accounts' : user?.name}</span>
                                        <span className='summary-sub-value'>{getPriceHelper(user?.expenses_paid)}</span>
                                    </div>
                                ))
                                    : ''}
                        </div>
                    )}

                    {/* Total Unpaid Expenses */}
                    <div className='summary-item' tabIndex={0}>
                        <div className='summary-item-header'>
                            <span className='summary-item-label'>Total Unpaid Expenses</span>
                            <span className='summary-item-value'>{getPriceHelper(filteredTotalExpUnPaid) || 0}</span>
                        </div>
                    </div>
                </div>


            </div>

            {showDeleteAllExpenseModal &&
                <CustomModal
                    title='Are you sure you would like to delete these expenses?'
                    buttonTxt={'Delete'}
                    onConfirm={handleDeleteAllExpense}
                    toggleModal={() => {
                        setDeleteData(false)
                        setShowDeleteAllExpenseModal(false)
                    }}
                />
            }
            {showDeleteExpenseModal &&
                <CustomModal
                    title='Are you sure you would like to delete this expense?'
                    buttonTxt={'Delete'}
                    onConfirm={handleDeleteExpense}
                    toggleModal={() => {
                        setDeleteData(false)
                        setShowDeleteExpenseModal(false)
                    }}
                />
            }
            {/* <div className="modal fade inner-modal com-modal" id="deleteAllExpenseModal" tabIndex={-1} aria-labelledby="deleteAllExpenseModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-body pt-4 pb-0">
                            <p className='com-modal-para mb-2 mt-3'>Are you sure you would like to <br /> delete these expense?</p>
                        </div>
                        <div className='modal-footer border-0 mt-3 justify-content-center'>
                            <button type='button' className='com-btn com-btn-gray btn-close-all-chores-modal' data-bs-dismiss="modal" disabled={updateExpense?.loading} onClick={() => setDeleteData(null)}>Cancel</button>
                            <Button type='button' className='com-btn' onClick={handleDeleteAllExpense} loading={updateExpense?.loading} >Confirm</Button>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* 
            <div className="modal fade inner-modal com-modal" id="deleteExpenseModal" tabIndex={-1} aria-labelledby="deleteExpenseModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-body pt-4 pb-0">
                            <p className='com-modal-para mb-2 mt-3'>Are you sure you would like to <br /> delete this expense?</p>
                        </div>
                        <div className='modal-footer border-0 mt-3 justify-content-center'>
                            <button type='button' className='com-btn com-btn-gray btn-close-delete-exp-modal' data-bs-dismiss="modal" >Cancel</button>
                            <Button type='button' className='com-btn' onClick={handleDeleteExpense} loading={updateExpense?.loading}>Confirm</Button>
                        </div>
                    </div>
                </div>
            </div> */}


            <EditExpenses
                hhMembers={hhMembers}
                payers={payers}
                finalizedMonths={expenses?.data?.data?.finalized_months}
                expensesCategories={expensesCategories}
                editExpense={editExpense}
                onCancel={() => setEditExpense(null)}
                onSuccess={() => {
                    getExpenses()
                    setEditExpense(null)
                }}
            />

            <EditAllExpences
                hhMembers={hhMembers}
                payers={payers}
                finalizedMonths={expenses?.data?.data?.finalized_months}
                expensesCategories={expensesCategories}
                editExpense={selectedExpenseArrayObj}
                onCancel={() => setEditExpense(null)}
                onSuccess={() => {
                    getExpenses()
                    setEditExpense(null)
                    setSelectedExpense([]);
                    setSelectedExpenseArrayObj([])

                }}
            />

            <MarkAsPaid
                payers={payers}
                finalizedMonths={expenses?.data?.data?.finalized_months}
                expensesCategories={expensesCategories}
                editExpense={selectedExpenseArrayObj}
                onCancel={() => setEditExpense(null)}
                onSuccess={() => {
                    getExpenses()
                    setEditExpense(null)
                    setSelectedExpense([]);
                    setSelectedExpenseArrayObj([])

                }}
            />

            {/*==== SHARE BETWEEN MODAL START ====*/}
            <div className="modal fade bottom-sheet-modal" id="sharedBetweenModal" tabIndex={-1} aria-labelledby="sharedBetweenModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {/* Bottom Sheet Handle */}
                        <div className="bottom-sheet-handle">
                            <div className="handle-bar"></div>
                        </div>
                        <div className="modal-header pt-0">
                            <h1 className="modal-title" id="sharedBetweenModalLabel">Shared Between</h1>
                        </div>
                        <div className="modal-body">
                            <ul className='shared-bw-list'>
                                {
                                    sharedBetweenMemb?.length > 0 ?
                                        sharedBetweenMemb?.map((memb: any, idx: number) => (
                                            <li key={idx} className="d-flex align-items-center">
                                                <img
                                                    src={memb?.split_user?.profile_pic || memb?.split_user?.profilePic || dummyUser}
                                                    alt={memb?.split_user?.name || 'Member'}
                                                    className="member-avatar"
                                                />
                                                <span className="member-name">{memb?.split_user?.name}</span>
                                            </li>
                                        ))
                                        : ''}
                            </ul>
                        </div>
                        <div className='modal-footer border-0 pt-0 pb-4'>
                            <button className='com-btn w-100' data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            {/*==== SHARE BETWEEN MODAL END ====*/}

        </>
    )
}

export default ExpensesList